import React, { useState } from 'react';
import Stepper from 'react-stepper-horizontal';

const Step1Component = () => {
    const [formData, setFormData] = useState({
        // Define your form fields and their initial values here
        name: '',
        email: '',
        // Add more fields as needed
    });

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = e => {
        e.preventDefault();
        // Handle form submission logic here
        console.log(formData);
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Name" />
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" />
            {/* Add more form fields as needed */}
            <button type="submit">Submit</button>
        </form>
    );
};

const Step2Component = () => {
    // Implement Step 2 form logic here
    return (
        <form>
            {/* Step 2 form fields */}
            <button>Submit</button>
        </form>
    );
};

const Step3Component = () => {
    // Implement Step 3 form logic here
    return (
        <form>
            {/* Step 3 form fields */}
            <button>Submit</button>
        </form>
    );
};

const YourFormComponent = () => {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        { title: 'Step 1' },
        { title: 'Step 2' },
        { title: 'Step 3' },
        // Add more steps as needed
    ];

    const handleStepChange = step => {
        setCurrentStep(step);
    };

    return (
        <div>
            <Stepper
                steps={steps}
                activeStep={currentStep}
                activeColor="#007bff" // Customize the active step color
                completeColor="#28a745" // Customize the completed step color
                size={100} // Customize the size of the steps
                circleFontSize={26} // Customize the font size inside the circles
                titleFontSize={16} // Customize the font size of step titles
            />

            {/* Your form content for the current step */}
            {currentStep === 0 && <Step1Component />}
            {currentStep === 1 && <Step2Component />}
            {currentStep === 2 && <Step3Component />}
            {/* Add more components for additional steps as needed */}

            {/* Navigation buttons */}
            <button onClick={() => handleStepChange(currentStep - 1)} disabled={currentStep === 0}>
                Previous
            </button>
            <button onClick={() => handleStepChange(currentStep + 1)} disabled={currentStep === steps.length - 1}>
                Next
            </button>
        </div>
    );
};

export default YourFormComponent;
